export class GuestIdentityDetails {
  firstName: string;
  lastName: string;
  birthDate: string;
  cityOfBirth: string;
  nationality: string;
  homeFullAddress: string;
  phone: string;
  email: string;
  identityPictureUrl: string;

  passportNumber: string;
  passportDeliveryDate: string;
  arrivalDate: string;
  departureDate: string;
  cityArrival: string;
  cityDeparture: string;
  numberOfNonAdults: number;
}
